import { Theme } from '@mui/material';
import { isArray } from 'lodash';

export type AnySpacingArgument = number | [number, number?, number?, number?];

export const getSpacing = (theme: Theme, spacing: AnySpacingArgument): number | string => {
  if (isArray(spacing)) {
    return theme.spacing(...(spacing as Parameters<Theme['spacing']>));
  }

  return theme.spacing(spacing);
};
